import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "HomePage",
    component: Home,
  },
  {
    path: "/solution/:type",
    name: "SolutionPage",
    component: () => import("../views/Solution.vue"),
  },
  {
    path: "/product",
    name: "ProductPage",
    component: () => import("../views/Product.vue"),
  },
  {
    path: "/product/productdetail/:type",
    name: "ProductDetailPage",
    component: () => import("../views/ProductDetail.vue"),
  },
  {
    path: "/about",
    name: "AboutPage",
    component: () => import("../views/About.vue"),
  },
  {
    path: "/job",
    name: "JobPage",
    component: () => import("../views/Job.vue"),
  },
  {
    path: "/media",
    name: "MediaPage",
    component: () => import("../views/Media.vue"),
  },
  {
    path: "/media/detail/:id",
    name: "MediaDetailPage",
    component: () => import("@/views/MediaDetail.vue"),
  },
  {
    path: "/error",
    name: "ErrorPage",
    component: () => import("@/views/Error.vue"),
  },
  {
    // 404通配路由，必须放在最后
    path: "*",
    redirect: {
      name: "ErrorPage",
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: "smooth",
      };
    }
    return { x: 0, y: 0 };
  },
});

export default router;
